import {EventEmitter} from "@angular/core";
import {UserSettingsService} from "../../user-settings.service";
import {OptionPricingGridMode} from "../options-pricing-grid-base.component";

const rootKey = 'opg-toolbar-visibility.';

export class ToolbarVisibilityManager {

    constructor(
        private readonly _userSettings: UserSettingsService,
        private readonly _mode: OptionPricingGridMode,
    ) {
    }

    readonly updated$ = new EventEmitter<void>();

    isVisible(elementKey: string): boolean {
        const v = this._userSettings.getValue<boolean>(this._fullKey(elementKey));
        return v !== false;
    }

    setVisible(elementKey: string, visible: boolean): void {
        this._userSettings.setValue(this._fullKey(elementKey), visible);
    }

    applyBatch(staged: ReadonlyMap<string, boolean>): boolean {
        let changed = false;
        staged.forEach((visible, key) => {
            const current = this.isVisible(key);
            if (current !== visible) {
                this.setVisible(key, visible);
                changed = true;
            }
        });
        if (changed) {
            this.updated$.emit();
        }
        return changed;
    }

    private _fullKey(elementKey: string): string {
        return `${rootKey}${this._mode}.${elementKey}`;
    }
}
